/**
 * 解码可能是 base64 或 URL 编码的链接
 * @param url 输入的 URL
 * @returns 解码后的 URL
 */
export function decodeJumpUrl(url: string): string | null {
  try {
    // 首先尝试 URL 解码
    const decodedUrl = decodeURIComponent(url);

    // 检查是否是 base64 编码
    if (isBase64(decodedUrl)) {
      try {
        const decoded = atob(decodedUrl);
        if (isValidUrl(decoded)) {
          return decoded;
        }
      } catch (e) {
        // base64 解码失败，返回原始解码结果
      }
    }

    // 如果不是 base64 或解码失败，返回 URL 解码结果
    return isValidUrl(decodedUrl) ? decodedUrl : null;
  } catch (e) {
    return null;
  }
}

/**
 * 检查字符串是否是有效的 URL
 * @param url 要检查的 URL
 * @returns boolean
 */
function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * 检查字符串是否是 base64 编码
 * @param str 要检查的字符串
 * @returns boolean
 */
function isBase64(str: string): boolean {
  try {
    const regex = /^[A-Za-z0-9+/]*={0,2}$/;
    return regex.test(str) && str.length % 4 === 0;
  } catch (e) {
    return false;
  }
}
